import { useParams, useSearchParams } from "react-router-dom";
import RwoView from "./RwoView";
import DwoView from "./DwoView";

type MediaViewProps = {
  selectedDate?: Date;
  attendanceId: string | null;
};

const TaskView = ({ selectedDate, attendanceId }: MediaViewProps) => {
  const { id } = useParams();

  const [searchParams] = useSearchParams();

  const post = searchParams.get("post");

  const fetchId = attendanceId ?? id!;

  const getRole = (post: string | null) => {
    if(!post) return;

    if( post === "RWO (Regional Wellness Officer)") return "rwo";
    if( post === "Senior DWO (District Wellness Officer)") return "dwo";
  };

  const role = getRole(post);

  const isFutureDate = (date?: Date | string | null) => {
    if (!date) return false;

    const selected = new Date(date);
    selected.setHours(0, 0, 0, 0);

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    return selected.getTime() > today.getTime();
  };

  if (isFutureDate(selectedDate) || !role) {
    return <div className="w-full p-12 text-center">No Task Updates</div>;
  }

  return (
    <div>
      {role && role === "rwo" ? (
        <RwoView attendanceId={fetchId} role={role}/>
      ) : role === "dwo" ? (
        <DwoView attendanceId={fetchId} role={role}/>
      ) : (
        <div>No Task</div>
      )}
    </div>
  );
};

export default TaskView;
